export const xeroContactConstants = {
  XERO_CONTACT_LIST_LOADING: 'XERO_CONTACT_LIST_LOADING',
  XERO_CONTACT_LIST_SUCCESS: 'XERO_CONTACT_LIST_SUCCESS',
  XERO_CONTACT_LIST_FAILURE: 'XERO_CONTACT_LIST_FAILURE',

  XERO_CONTACT_EDIT_LOADING: 'XERO_CONTACT_EDIT_LOADING',
  XERO_CONTACT_EDIT_SUCCESS: 'XERO_CONTACT_EDIT_SUCCESS',
  XERO_CONTACT_EDIT_FAILURE: 'XERO_CONTACT_EDIT_FAILURE'
};
